import React, { FunctionComponent } from 'react';
import {
  FormLabelProps,
  InputProps,
  FormErrorMessageProps,
  TextProps,
  StyleProps,
  InputLeftAddonProps,
} from '@chakra-ui/react';
import InputComponent from './Input';
import HOCs from '../HOCs';

export type TIndex = {
  name: string;
  isFormik?: boolean;
  label?: string;
  error?: string;
  helperText?: string;
  propsLabel?: FormLabelProps;
  propsError?: FormErrorMessageProps;
  propsHelper?: TextProps;
  sxWrapper?: StyleProps;
  InputLeftAddon?: string;
  InputRightAddon?: string;
  InputRightElement?: FunctionComponent;
  InputLeftElement?: FunctionComponent;
  inputLeftAddonSx?: InputLeftAddonProps;
} & InputProps;

export default function Input({
  isFormik = true,
  name,
  label,
  error,
  helperText,
  propsLabel,
  propsError,
  propsHelper,
  sxWrapper,
  ...rest
}: TIndex) {
  const id = `${name}-input`;

  return (
    <HOCs
      {...{
        isFormik,
        id,
        name,
        label,
        error,
        helperText,
        propsLabel,
        propsError,
        propsHelper,
        sxWrapper,
      }}
    >
      <InputComponent id={id} name={name} {...rest} />
    </HOCs>
  );
}
